<template>
  <svg
    id="icon_checklist"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 16"
    fill="none"
    :width="resolvedWidth"
    :height="resolvedHeight"
  >
    <title>{{ resolvedTitle }}</title>
    <path
      d="M8.625 3.07H0V5.07H8.625V3.07ZM8.625 11.07H0V13.07H8.625V11.07ZM13.7425 7.07L10.35 3.53L11.7013 2.12L13.7329 4.24L17.7962 0L19.1667 1.41L13.7425 7.07ZM13.7425 15.07L10.35 11.53L11.7013 10.12L13.7329 12.24L17.7962 8L19.1667 9.41L13.7425 15.07Z"
      :fill="resolvedFill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: { type: String, default: null },
    size: { type: [String, Number], default: "20px" },
    title: { type: String, default: "Checklist" },
  },
  computed: {
    resolvedFill() {
      if (!this.color) return "#536DFE";
      const themeName = this.$store?.state?.theme;
      const themes = this.$vuetify?.theme?.themes;
      const fromTheme =
        themes?.[themeName]?.[this.color] ?? themes?.light?.[this.color];
      if (fromTheme) return fromTheme;
      return this.getColor(this.color);
    },
    resolvedTitle() {
      return this.title || "Checklist";
    },
    resolvedWidth() {
      if (this.size == null || this.size === "") return "20px";
      if (typeof this.size === "number") return `${this.size}px`;
      return this.size;
    },
    resolvedHeight() {
      return this.scaleDimension(this.resolvedWidth, 16 / 20);
    },
  },
  methods: {
    scaleDimension(value, ratio) {
      if (typeof value === "number") return `${value * ratio}px`;
      const match = String(value).match(/^(-?\d*\.?\d+)([a-z%]*)$/i);
      if (!match) return value;
      const [, numericPart, unit = ""] = match;
      return `${Number(numericPart) * ratio}${unit}`;
    },
  },
};
</script>

<style>
svg {
  display: block;
  margin: 0 auto;
}
</style>
